import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';
import { UserService, OperationsService, AuthenticationService, StorageService, DataService } from '../_services/index';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-walletdetails',
  templateUrl: './walletdetails.component.html',
  styleUrls: ['./walletdetails.component.css']
})
export class WalletdetailsComponent implements OnInit {
  withdrawWallet = false;
  has_account_attached = false;
  has_card_attached = false;
  has_disbursement_account_attached = false;
  has_repayment_account_attached = false;
  @Input('state') state: any;
  @Output() openWalletStatement = new EventEmitter();
  @Input('loading') loading = false;
  @Input('from_where') from_where = 'self';
  @Input('customer_id') customer_id :any;
  isWalletSettings = false;
  view = 'wallet';
  showPicture = false;
  singlebank = false;
  isremita = false;
  isdelete = false;
  has_ebills_error = false;
  ebills_error = '';
  showForm = true;
  fresponse = '';
  public nigerian_banks: any;
  currentUser: any;
  VERIFY_STATUS = false;
  confirming = true;
  charge_account = false;
  public bank = {
    LENDER_BANK_BANK_NAME: '',
    LENDER_BANK_ACCOUNT_NAME: '',
    LENDER_BANK_CODE: '',
    LENDER_BANK_ACCOUNT_ID: '',
    LENDER_ACCOUNT_NUMBER: '',
    LENDER_BANK_ID: '',
    LENDER_ACCOUNT_GL: '',
    LENDER_ID: '',
    ADDED_BY: '',
    DATE_ADDED: '',
    PARENT_GL_ID: '',
    DATE_MODIFIED: '',
    IS_FOR_EBILLS: false
  };
  lenderbanksaved = false;
  walletaccount: any;
  fundPlatformWallet = false;
  account_details: any;
  card_details: any; 
  repayment_account: any;
  disbursement_account: any;
  wallet_balance: any;
  wallet_settings: any;
  bank_type = '1';
  updateWalletSettings = false;
  topupWallet = false;
  wallettopup = {
    'PASSWORD':'',
    'AMOUNT':'0',
    'TRANSACTION_REFERENCE':'',
    'TOKEN':'',
    'PIN':''
  } 
  topupstep = '1';
  lender_banks:any;
  constructor(public authService: AuthenticationService, public fb: FormBuilder,
    public operationsService: OperationsService, public toastr: ToastrService,
    public storageService: StorageService, private dataService: DataService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.operationsService.getNigerianBanks(this.currentUser.token).subscribe(nigerian_banks => this.nigerian_banks = nigerian_banks);
    this.dataService.cardHasBeenTokennized.subscribe(res => {
      this.getWalletAccountStatus();
    });
    this.dataService.closeDisbursementModal.subscribe(res => { 
      this.addingAccount(2);
    }); 
  }

  ngOnInit() {
    this.getWalletAccountStatus(); 
    this.getLenderBanks();
  }
  
  getLenderBanks() {
    this.operationsService.getBanks_(this.currentUser.token)
      .subscribe(banks => {
        this.lender_banks = banks;
      });
  }
  changeBankCode_(event) {
    this.VERIFY_STATUS = false;
    this.loading = false;
  }
  updateBankDetails(bank) {
    this.showForm = true;
    this.bank = bank;
  }
  fundWallet() {

  }
  save(value, valid) {

  }
  openView(view) {
    this.view = view;
  }
  addingAccount(event) {
    this.bank_type = event
    this.showPicture = true;
  }
  addingCard() {
    this.fundPlatformWallet = true;
  }
  showMessage(event){
    this.showSuccess(event.message);
  }
  showEMessage(event){
    this.showError(event.message);
  }
  cancelAction(){
    
  }
  saveSettings(){
    this.loading = true;
    this.operationsService.saveWalletDisbursementSetting(this.currentUser.token, this.wallet_settings)
      .subscribe(status => {
        this.loading = false;

        if (status.status == '1') { 
          this.loading = false; 
          this.getWalletAccountStatus();
          this.showSuccess(status.message);
        } else { 
          this.showError(status.message);
        }
      });
  }
  saveLenderBank() {
    this.loading = true;
    this.operationsService.saveBankAccount(this.currentUser.token, this.bank, this.bank_type)
      .subscribe(status => {
        this.loading = false;

        if (status.status == '1') {
          this.lenderbanksaved = true;
          this.loading = false;
          this.confirming = true;
          this.showForm = false;
          this.getWalletAccountStatus();
          this.showSuccess(status.message);
        } else {
          this.lenderbanksaved = false;
          this.showError(status.message);
        }
      });

  }
  saveSelectedLenderBank(event){ 
    this.loading = true;
    this.operationsService.saveSelectedLenderBank(this.currentUser.token, event, this.bank_type)
      .subscribe(status => {
        this.loading = false;

        if (status.status == '1') {
          this.lenderbanksaved = true;
          this.loading = false;
          this.confirming = true;
          this.showForm = false;
          this.getWalletAccountStatus();
          this.showSuccess(status.message);
        } else {
          this.lenderbanksaved = false;
          this.showError(status.message);
        }
      });
  }
  verifyAccount(bank) {
    this.bank = bank;
    this.loading = true;
    this.VERIFY_STATUS = false;
    this.operationsService.confirmBankAccount(this.currentUser.token, this.bank)
      .subscribe(status => {
        this.loading = false;

        if (status.status == 'success') {
          this.VERIFY_STATUS = false;
          this.charge_account = true;
          this.bank.LENDER_BANK_ACCOUNT_NAME = status.data.account_name;
        } else {
          this.VERIFY_STATUS = true;
        }
      });
  }
  changeBankCode(event) {
    if (event.status == true) {
      this.charge_account = false;
      this.VERIFY_STATUS = false;
      this.loading = false;
      this.bank.LENDER_BANK_CODE = event.event.BANK_CODE;
      this.bank.LENDER_BANK_BANK_NAME = event.event.BANK_NAME;
      this.bank.LENDER_BANK_ID = event.event.BANK_ID;
      this.bank.LENDER_BANK_ACCOUNT_NAME = '';
      this.bank.LENDER_ACCOUNT_NUMBER = '';
    } else {
      this.charge_account = false;
      this.VERIFY_STATUS = false;
      this.loading = false;
    }

  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  getWalletAccountStatus() {
    this.loading = true;
    if(this.from_where =='self'){
      this.operationsService.getWalletAccountStatus(this.currentUser.token)
      .subscribe(res => {
        this.loading = false;
        this.has_account_attached = res.data.has_account_attached;
        this.has_card_attached = res.data.has_card_attached;
        this.account_details = res.data.account_details;
        this.card_details = res.data.card_details;
        this.wallet_balance = res.data.wallet_balance;
        this.wallet_settings = res.data.wallet_settings;

        this.has_repayment_account_attached = res.data.has_repayment_account_attached;
        this.has_disbursement_account_attached = res.data.has_disbursement_account_attached;
        this.disbursement_account = res.data.disbursement_account;
        this.repayment_account = res.data.repayment_account;  
        this.wallettopup.AMOUNT = this.wallet_settings.MAX_DAILY_FUNDING || 0;
      });
    }else{
      this.operationsService.getCustomerWalletAccountStatus(this.currentUser.token, this.customer_id)
      .subscribe(res => {
        this.loading = false; 
        this.account_details = res.data.account_details; 
        this.wallet_balance = res.data.wallet_balance; 

        
      });
    }

  }
  openStatement(){
    this.wallettopup.AMOUNT=this.wallet_settings.MAX_DAILY_FUNDING || 0;
    this.wallettopup.PASSWORD='';
    this.wallettopup.TOKEN='';
    this.wallettopup.PIN='';
    this.openWalletStatement.emit();
  }
  confirmWalletTop(){
    this.loading = true;
    this.operationsService.doWalletTopUp(this.currentUser.token, this.wallettopup, {})
      .subscribe(res => {
        this.loading = false;
        if(res.status == "success"){
          if(res.data.transfer.flutterChargeResponseCode=='02'){
            this.topupstep = '2';
            this.wallettopup.TRANSACTION_REFERENCE = res.data.transfer.flutterChargeReference;
          }else{
            this.topupWallet = false;
            this.showSuccess('Wallet funding successful');
            this.getWalletAccountStatus(); 
          }
        }
        if(res.status == false){
          this.showError("Unable to perform request");
        }
      });
  }
  finishtopup(){
    this.loading = true;
    this.operationsService.finishWalletTopUp(this.currentUser.token, this.wallettopup, {})
      .subscribe(res => {
        
        this.loading = false;
        if(res.status=="success"){
          this.topupstep = '1';
          this.wallettopup.AMOUNT=this.wallet_settings.MAX_DAILY_FUNDING || 0;
          this.wallettopup.PASSWORD='';
          this.wallettopup.TOKEN='';
          this.wallettopup.PIN='';
          this.topupWallet = false;
            this.showSuccess('Wallet funding successful');
            this.getWalletAccountStatus(); 
        }else{
          this.showError("Unable to perform request");
        }
      });
  }
} 
